import React, { Component } from 'react';
import ModalContainer from 'react-modal-promise';

import customPlanPricingPage from 'decorators/customPlanPricingPage';
import ViewCustomPlanPricingTable from 'components/ViewCustomPlanPricingTable';
import CustomPlanPricingDeleteModal from 'components/CustomPlanPricingDeleteModal';
import CustomPlanPricingUpdateModal from 'components/CustomPlanPricingUpdateModal';
import Button from 'react-bootstrap/lib/Button';
import FormError from 'components/FormError';
import Spinner from 'components/Spinner';
import { can, permActions } from 'permissions';

class ViewCustomPlanPricing extends Component {
  state = {
    isModalOpen: false,
    csvError: '',
    csvLoading: false,
    isUpdateModalOpen: false,
    currentCustomPlan: null,
    updateError: null,
  };

  clearError = () => {
    this.setState({ error: null, updateError: null });
  };

  closeUpdateModal = () =>
    this.setState({ isUpdateModalOpen: false, updateError: null });

  handleOpenDeleteModal = async (customPlanPricing) => {
    this.clearError();
    if (!customPlanPricing) {
      return;
    }

    const { deleteCustomPlanPricing, history } = this.props;
    const { id } = customPlanPricing;

    try {
      this.setState({ isModalOpen: true });
      const confirmResult = await CustomPlanPricingDeleteModal({
        open: this.state.isModalOpen,
        customPlanPricing,
      });

      if (confirmResult) {
        this.setState({ isEditState: false });
        await deleteCustomPlanPricing(id);
        history.push('/custom-plan-prices');
      }
    } catch (error) {
      this.setState({ isModalOpen: false, error: { message: error.message } });
    }
  };

  handleOpenUpdateModal = async (customPlanPricing) => {
    this.clearError();
    if (!customPlanPricing) {
      return;
    }
    this.setState({
      isUpdateModalOpen: true,
      currentCustomPlan: customPlanPricing,
    });
  };

  handleUpdatePlan = async (values) => {
    const { currentCustomPlan } = this.state;
    const { updateCustomPlanPricing } = this.props;
    const { id } = currentCustomPlan;

    try {
      this.setState({ isEditState: false });
      await updateCustomPlanPricing(id, values);
      this.setState({ isUpdateModalOpen: false, currentCustomPlan: null });
    } catch (error) {
      this.setState({ updateError: { message: error.message } });
    }
  };

  render() {
    const {
      loggedInUser,
      customPlanPricing,
      isPendingUpdate,
      isPendingDelete,
    } = this.props;
    const { error, isUpdateModalOpen, updateError, currentCustomPlan } =
      this.state;
    const showLoader = isPendingUpdate || isPendingDelete;
    const showModify =
      can(loggedInUser, permActions.MODIFY_CUSTOM_PLAN) &&
      customPlanPricing.is_effective;

    if (!customPlanPricing) {
      return (
        <div style={{ marginTop: '200px' }}>
          <Spinner showLoader={!customPlanPricing} />
        </div>
      );
    }

    return (
      <div>
        <h1>Custom Plan Pricing Details</h1>
        <ViewCustomPlanPricingTable customPlanPricing={customPlanPricing} />
        {showModify && (
          <div className="d-flex mar-t mar-b">
            <Button
              className="mar-r"
              bsStyle="warning"
              onClick={() => this.handleOpenUpdateModal(customPlanPricing)}
            >
              Update
            </Button>
            <Button
              bsStyle="danger"
              onClick={() => this.handleOpenDeleteModal(customPlanPricing)}
            >
              Delete
            </Button>
          </div>
        )}
        {error && (
          <React.Fragment>
            <br />
            <FormError error={error} />
          </React.Fragment>
        )}
        <ModalContainer />
        <CustomPlanPricingUpdateModal
          isOpen={isUpdateModalOpen}
          customPlanPricing={currentCustomPlan}
          onClose={this.closeUpdateModal}
          onConfirm={this.handleUpdatePlan}
          error={updateError}
        />
        <Spinner showLoader={showLoader} />
      </div>
    );
  }
}

export default customPlanPricingPage(ViewCustomPlanPricing);
